import React, { useEffect } from "react";
import Routing from "./Routing";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import TopNav from "./utils/TopNav";
import BottomNav from "./utils/BottomNav";
import Navbar from "./utils/Navbar";
import Footer from "./utils/Footer";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { fetchBuyline } from "./store/slices/buylineSlice";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchBuyline());
  }, []);
  return (
    <PayPalScriptProvider
      options={{
        "client-id":
          "AVKrtvg-vvVqgXhAglTsGoni0w0A4H4MpRbMjMEjNpKLh_gucVHp8BAGCfoo-WQm_IbumJ2PtuA5pFHG",
        currency: "GBP",
      }}
    >
      <TopNav />
      <Navbar />
      <BottomNav color={`#CEB600`} isVisible={true} />
      <Routing />
      <Footer />
    </PayPalScriptProvider>
  );
}

export default App;
